'use strict';

/* Components */
import dropdownToggleDirective from './dropdown-toggle/dropdown-toggle.directive';
import footer from './footer/footer.component';
import inplaceEditHover from './inplace-edit-hover/inplace-edit-hover.directive';
import jsonViewComponent from './json-view/json-view.component';
import jsonViewDirective from './json-view/json-view.directive';
import modal from './modal/modal.service';
import mongooseError from './mongoose-error/mongoose-error.directive';
import newlineToHtml from './newline-to-html/newlineToHtml.filter';
import socket from './socket/socket.service';
import startFrom from './start-from/startFrom.filter';
import util from './util/util.module';
import datatableViewer from './datatable-view/datatable-view.component';

import activateDeactivateFormComponent from './activate-deactivate-form/activate-deactivate-form.component';

/* Module */
export default angular.module('conduu.ap.components', [
  dropdownToggleDirective, footer, inplaceEditHover, jsonViewComponent, jsonViewDirective, modal, mongooseError,
  newlineToHtml, socket, startFrom, util, datatableViewer, activateDeactivateFormComponent])
.name;



// WEBPACK FOOTER //
// ./client/~ap/components/index.js